<template>
    <component
        :is="componentToRender"
        :field-name="fieldName"
        :props-value="field.value"
        :uploaded-images="field.value"
        :upload-handler="uploadImagesForPages"
        v-model="field.value"
        @update-content="updateFieldInfo"
    />
</template>

<script>
import TextField from "./TextField.vue";
import MultipleImage from "./MultipleImage.vue";
import TinyMce from "./TinyMce.vue";
import ImageGalleryWithTitles from "./ImageGalleryWithTitles.vue";
import AdminPanelService from "../../../services/AdminPanelService";
import SingleImageUploader from "./SingleImageUploader.vue";
import TabListWithTitles from "./TabListWithTitles.vue";

export default {
    props: {
        pageId: Number,
        field: {
            type: [Object, Array],
            required: true
        },
        fieldName: String
    },
    components: {
        TextField,
        MultipleImage,
        TinyMce,
        ImageGalleryWithTitles,
        SingleImageUploader,
        TabListWithTitles
    },
    methods: {
        async uploadImagesForPages(formData) {
            return await AdminPanelService.uploadFilesForPages(this.pageId, formData)
        },
        updateFieldInfo(result) {
            this.$emit('update-content',
                {field: this.fieldName, content: result, type: this.field.type}
            )
        }
    },
    computed: {
        componentToRender() {
            const map = {
                text: 'TextField',
                image: 'SingleImageUploader',
                images: 'MultipleImage',
                html_text: 'TinyMce',
                image_with_data: 'ImageGalleryWithTitles',
                tab: 'TabListWithTitles'
            };
            return map[this.field.type] || 'TextField';
        }
    }
}
</script>
